import { clinicasApi } from '../../../api';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';

export const startAsistencia = (membresia, cita) => {
    return async(dispatch) => {

        try {

            dispatch(successNotification('Conectando...'));

            const { data } = await clinicasApi.post(`/consultas/asistencia/OnDemand?idMembresia=${encodeURIComponent(membresia)}&idCita=${encodeURIComponent(cita)}&asistio=true`);

            if (data.status) {

                dispatch(clearNotifications());
                dispatch(successNotification('Asistencia registrada'));

                return true;

            } else {

                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al registrar asistencia'));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición'));

            }

            return false;

        }

    }
}